const votingMixin = {
	computed: {
	},
	methods: {
		__getAgendaStatusIcon(status) {
			let iconName = 'radio_button_unchecked';
			switch (status) {
			case 'active': iconName = 'radio_button_checked'; break;
			case 'closed': iconName = 'check_circle'; break;
			default: iconName = 'radio_button_unchecked'; break;
			}
			return iconName;
		},
		__getAgendaStatusFilterLabel(status) {
			let statusLabel = this.$t('allStatus');
			switch (status) {
			case 'active': statusLabel = this.$t('activeAgenda'); break;
			case 'closed': statusLabel = this.$t('completedAgenda'); break;
			case 'open': statusLabel = this.$t('Upcoming agenda'); break;
			default: statusLabel = this.$t('all'); break;
			}
			return statusLabel;
		},
	},
	mounted() {
	},
};

export default votingMixin;
